/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { MenuConfigModel } from '../../../../core/models';

export const DeepThoughtMenu: MenuConfigModel = {
    menuTitle: null,
    menuSubTitle: null,
    hideMenuTitle: true,
    menuItems: [
        {
            location: './dashboard',
            heading: 'dashboard',
            id: 'menu-dashboard',
            iconLocation: 'loadbalancer/icons/overview',
            hidden: false
        },
        {
            location: './organisations',
            heading: 'organizations',
            id: 'menu-organisations',
            iconLocation: 'loadbalancer/icons/overview',
            hidden: false
        },
        {
            location: './accounts',
            heading: 'accounts',
            id: 'menu-accounts',
            iconLocation: 'loadbalancer/icons/overview',
            hidden: false
        }
    ]
};
